import * as React from 'react';
import { SVGProps } from 'react';

const IconBarrierSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.5 3a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V6.5H1v-1h3.5V3ZM11 5.5H9v1h2v-1Z"
    />
  </svg>
);
export default IconBarrierSizeXs;
